import React, {Fragment, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import NumberFormat from "react-number-format";
import DatePicker, {registerLocale} from "react-datepicker";
import es from "date-fns/locale/es";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle,  faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import {facturaRestauranteConstraints, facturaRestauranteFormDefault} from "./FacturaRestauranteForm";
import {setParametrosBusqueda} from "../../actions/busqueda/busquedaAction";
import useForm from "../../hooks/useForm";
import {requests} from "../../constants/config";
import {EXITO} from "../../constants/enviroment";
import axios from "../../axios";
import Spinner from "../../components/Spinner";
import Alert from "../../components/SweetAlert";
import tienda from '../../assets/img/helps/facturaRestauranteTienda.png';
import operacion from '../../assets/img/helps/facturaRestauranteFolio.png';
import fecha from '../../assets/img/helps/facturaRestauranteFecha.png';
import importe from '../../assets/img/helps/facturaRestauranteImporte.png';

registerLocale("es", es);

const BusquedaOperacionRestaurante = (props) => {
    const dispatch = useDispatch();
    const tiendas = useSelector(state => state.tiendas);
    const [buscando, setIsBuscando] = useState(false);
    const [error, setErrores] = useState('');

    const {
        form,
        handleFormChange,
        isFormValid,
        getValue
    } = useForm(facturaRestauranteFormDefault, facturaRestauranteConstraints);

    const setForm = async (event) => {
        handleFormChange(event);
    };

    const disabledButton = () => {
        return !isFormValid();
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsBuscando(true);
        setErrores('');

        const formatDate = {day:'numeric', month:'numeric', year:'numeric'}
        axios.post(requests.facturacionRestaurante.validarOperacion, {
            type: 'R',
            operationNumber: parseInt(getValue('folioSVA')),
            location: parseInt(getValue('cvetda')),
            total: Number(getValue("importe").replace(/[\$,]/g, '')),
            tranDate: getValue('fechaCompra').toLocaleDateString('es-ES', formatDate)
        })
        .then(res => {
            let idNetsuite = res.data.idNetsuite;
            let code = res.data.mensaje.codigo;
            let mensaje = res.data.mensaje.descripcion;
            let parametrosBusqueda = {
                ...form.values,
                idNetsuite
            }
            dispatch(setParametrosBusqueda(parametrosBusqueda));
            setIsBuscando(false);

            if (code === EXITO) {
                props.nextStep();
            } else {
                setErrores(mensaje);
            }
        }).catch((error) => {
            setIsBuscando(false);
            setErrores('Ocurrió un error, verifique sus datos de búsqueda.');
        });
    };

    return (
        <Fragment>
            <h3>Ingrese la información para facturar su consumo</h3>
            <p>Consulte la información de su consumo en Restaurante en su <strong>Ticket</strong>.</p>
            {/*<div className="mb-40">
                <a className="btn btn--large btn-info"
                    href="/">Preguntas frecuentes {' '} 
                        <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                        icon={faInfoCircle}/>
                </a>
            </div>*/}
            

            {(error !== null && error !== '') ?
                <div className="alert alert-warning" role="alert">
                    <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                     icon={faExclamationTriangle}/> {error}
                </div> : ''
            }

            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <div>
                            <label htmlFor="cvetda">Tienda*:</label>
                            <button type='button' className='btn btn-help' onClick={() => Alert(tienda, 'Tienda', 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>
                        </div>
                        <select 
                            className="form-control" id="cvetda" name="cvetda"
                            value={getValue('cvetda') || '0'}
                            onChange={setForm}
                            disabled={buscando}
                        >
                            <option key={-1} value="0" disabled>Seleccionar tienda</option>
                            {tiendas.tiendas != null && tiendas.tiendas.map((tienda, i) => (
                                <option key={i} value={tienda.cvetda}>GRAN {tienda.nombre}</option>
                            ))}
                        </select>
                    </div>
                
                    <div className="form-group col-md-6">
                        <div>
                            <label htmlFor="folioSVA">Folio restaurante*:</label>
                            <button type='button' className='btn btn-help' onClick={() => Alert(operacion, "Folio", 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>
                        </div>
                        <NumberFormat
                            className="form-control" id="folioSVA" name="folioSVA"                          
                            value={getValue('folioSVA') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            allowNegative={false}
                            placeholder="Folio"
                            maxLength="10"
                            autoComplete="off"
                            decimalScale="0"
                            decimalSeparator={false}                    
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-6">
                        <div>
                            <label htmlFor="fechaCompra">Fecha*:</label>
                            <button type='button' className='btn btn-help' onClick={() => Alert(fecha, 'Fecha', 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>
                        </div>
                        <DatePicker 
                            className="form-control" id="fechaCompra" name="fechaCompra" 
                            selected={getValue('fechaCompra')}                        
                            value={getValue('fechaCompra') || ''}
                            onChange={setForm}   
                            disabled={buscando}
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                            autoComplete="off"
                            locale="es"
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <div>
                            <label htmlFor="importe">Importe*:</label>
                            <button type='button' className='btn btn-help' onClick={() => Alert(importe, 'Importe', 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>
                        </div>
                        <NumberFormat
                            className="form-control" id="importe" name="importe"
                            value={getValue('importe') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            allowNegative={false}
                            placeholder="Importe de la operación"
                            maxLength="11"
                            autoComplete="off"
                            thousandSeparator={true}
                            prefix={'$'}
                        />
                    </div>
                </div>
                
                <button type="submit" className="btn btn-lg btn-chapur btn-block mt-30"
                        disabled={buscando || disabledButton()}>
                    {!buscando ? 'Buscar' : 'Buscando...'}
                    {buscando && <Spinner/>}
                </button>
            </form>
        </Fragment>
    );
};

export default BusquedaOperacionRestaurante;